import React, { useState, useEffect } from "react";

const C = {
  bg: "#f5ead4",
  bgHeader: "#6b3a1f",
  text: "#3d1f0a",
  textMuted: "#9b8a74",
  gold: "#8b6f3a",
  goldLight: "#c9a96e",
  border: "#d4c4a0",
  current: "#8b2500",
};

const Parchment = ({ zmanimList = [], title, showTitle = true, hebrewDate, countdown }) => {
  const [now, setNow] = useState(new Date());
  useEffect(() => {
    const t = setInterval(() => setNow(new Date()), 30000);
    return () => clearInterval(t);
  }, []);

  const dayName = now.toLocaleDateString("he-IL", { weekday: "long" });
  const dateLabel = hebrewDate?.hebrewShort ? `${dayName} ${hebrewDate.hebrewShort}` : dayName;
  const hhmm = `${String(now.getHours()).padStart(2, "0")}:${String(now.getMinutes()).padStart(2, "0")}`;

  return (
    <div style={{
      direction: "rtl", width: "100%", height: "100%",
      backgroundColor: C.bg, overflow: "hidden",
      display: "flex", flexDirection: "column",
      fontFamily: "inherit",
      border: `2px solid ${C.goldLight}`,
      boxSizing: "border-box",
    }}>
      {showTitle && (
        <div style={{
          backgroundColor: C.bgHeader,
          borderBottom: `3px solid ${C.goldLight}`,
          padding: "0.9rem 1.5rem",
          display: "flex", flexDirection: "column", alignItems: "center", gap: "4px",
          flexShrink: 0,
        }}>
          <span style={{ color: C.goldLight, fontWeight: 700, fontSize: "1.3em", letterSpacing: "1px" }}>{title}</span>
          <span style={{ color: "#d4c4a8", fontSize: "0.85em", opacity: 0.85 }}>{dateLabel}</span>
          {countdown && (
            <div style={{ display: "flex", alignItems: "center", gap: "6px", marginTop: "2px" }}>
              <span style={{ color: "#d4c4a8", fontSize: "0.8em" }}>{countdown.label}</span>
              <span style={{ color: "#d4c4a8", fontSize: "0.75em", opacity: 0.7 }}>{"\u05D1\u05E2\u05D5\u05D3"}</span>
              <span style={{ color: "#ff9966", fontSize: "1em", fontWeight: 700, fontVariantNumeric: "tabular-nums" }}>{countdown.remaining}</span>
            </div>
          )}
        </div>
      )}

      <div style={{ flex: 1, overflow: "auto", padding: "0.6rem 1rem" }}>
        {zmanimList.map((item, i) => {
          const toMinAdj = t => { const [h, m] = t.split(":").map(Number); return (h === 0 ? 24 : h) * 60 + m; };
          const isPast = toMinAdj(item.time) < toMinAdj(hhmm);
          const isCurrent = item.time === hhmm;
          return (
            <div key={item.key} style={{
              display: "flex", justifyContent: "space-between", alignItems: "center",
              padding: "0.55rem 0.5rem",
              opacity: isPast ? 0.65 : 1,
              borderBottom: i < zmanimList.length - 1 ? `1px dashed ${C.border}` : "none",
              backgroundColor: isCurrent ? `${C.current}0c` : "transparent",
              borderRadius: isCurrent ? "4px" : 0,
            }}>
              <span style={{
                color: isCurrent ? C.current : C.text,
                fontSize: "0.95em", fontWeight: isCurrent ? 700 : 500,
                whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis",
                flex: 1, minWidth: 0,
              }}>{item.label}</span>
              <span style={{
                color: isCurrent ? C.current : C.gold,
                fontSize: "1em", fontWeight: 700,
                fontVariantNumeric: "tabular-nums", flexShrink: 0, marginRight: "10px",
              }}>{item.time}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Parchment;
